<style lang="css">
img {
  width: 100%;
}
</style>

<template lang="html">

<el-form v-form @onAdded="goPage" :model="carExhibitionActivityForm" editAction="carShow/business/updateActivity.action" addAction="carShow/business/insertActivity.action" selectAction="carShow/business/selectActivityInfo.action" :rules="rules" label-width="120px">
    <el-form-item label="活动名称：" prop="name">
        <el-input v-model="carExhibitionActivityForm.name" placeholder="请输入活动名称（30字内）"></el-input>
    </el-form-item>
    <el-form-item label="活动时间：" prop="rangeDate">
        <el-date-picker v-model="carExhibitionActivityForm.rangeDate" type="daterange" range-separator="至" @change="onDateTimeRangeChange" start-placeholder="活动开始日期" end-placeholder="活动结束日期">
        </el-date-picker>
    </el-form-item>

    <el-form-item label="活动内容：" prop="describes">
      <wang-edit ref="wang-edit" style="width:40%" @change="onEidtChange"></wang-edit>
    </el-form-item>
    <el-form-item>
        <el-button type="primary">保存</el-button>
    </el-form-item>
</el-form>

</template>

<script>
import WangEdit from '@/components/WangEdit'

export default {
  components: {
    WangEdit
  },
  data: function () {
    return {
      carExhibitionActivityForm: {
        rangeDate: [],
        describes: null
      },
      rules: {
        name: [{
          required: true,
          message: '请输入商品名称',
          trigger: 'blur'
        }, {
          max: 30,
          message: '商品名称最多30字以内',
          trigger: 'blur'
        }],
        describes: [{
          required: true,
          message: '请输活动内容',
          trigger: 'change'
        }],
        rangeDate: [{
          required: true,
          message: '请选择活动时间',
          trigger: 'change'
        }]
      }
    }
  },
  created: function () {
    let params = this.$route.query
    if (params.businessId) {
      this.carExhibitionActivityForm.businessId = params.businessId
    }
    if (params.carShowId) {
      this.carExhibitionActivityForm.carShowId = params.carShowId
    }

    if (params.id) {
      this.carExhibitionActivityForm.id = params.id
    }
  },
  methods: {
    goPage: function (data) {
      this.$router.push({ name: '车展活动', query: { businessId: this.carExhibitionActivityForm.businessId, carShowId: this.carExhibitionActivityForm.carShowId } })
    },
    onEidtChange: function (html) {
      this.carExhibitionActivityForm.describes = html
    },
    onSelectInfo: function (dataInfo) {
      let params = dataInfo.datas
      this.carExhibitionActivityForm.rangeDate = [new Date(params.startTime), new Date(params.endTime)]

      this.$refs['wang-edit'].setContent(params.describes)
    },
    onDateTimeRangeChange: function (dateTimeRange) {
      if (!dateTimeRange) {
        this.carExhibitionActivityForm.startTime = null
        this.carExhibitionActivityForm.endTime = null
        return
      }

      if (dateTimeRange[0] && dateTimeRange[1]) {
        this.carExhibitionActivityForm.startTime = dateTimeRange[0].getTime()
        this.carExhibitionActivityForm.endTime = dateTimeRange[1].getTime()
      }

      this.$refs['table-template'].search()
    }
  }
}

</script>
